import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(marketing)/ogami/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Ogami/OgamiAboutus/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Ogami/OgamiAmenities/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Ogami/OgamiBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Ogami/OgamiDestination/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Ogami/OgamiFooter/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Ogami/OgamiHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Ogami/OgamiIntroduction/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Ogami/OgamiRegistration/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Ogami/OgamiShowcase/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ComingSoon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonTransition/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisclaimerToggleProvider"] */ "/app/src/hooks/useDisclaimerToggle.tsx");
